var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "topbar" }, [
    _c(
      "nav",
      { staticClass: "navbar top-navbar navbar-expand-md navbar-light" },
      [
        _c(
          "div",
          {
            staticClass: "navbar-header",
            staticStyle: { "background-color": "#262626" },
          },
          [
            _c("a", { staticClass: "navbar-brand", attrs: { href: "/" } }, [
              _c("img", { attrs: { src: _vm.getIcon } }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "navbar-collapse" }, [
          _c("ul", { staticClass: "navbar-nav mt-md-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm.getConfig("maintenance_mode")
              ? _c("li", { staticClass: "nav-item d-none d-sm-inline" }, [
                  _c(
                    "span",
                    { staticClass: "mt-4 badge badge-danger m-b-10" },
                    [
                      _vm._v(
                        _vm._s(_vm.trans("configuration.under_maintenance"))
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.getConfig("mode")
              ? _c("li", { staticClass: "nav-item d-none d-sm-inline" }, [
                  _c(
                    "span",
                    { staticClass: "mt-4 badge badge-danger m-b-10" },
                    [_vm._v(_vm._s(_vm.trans("configuration.test_mode")))]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "nav-item hidden-sm-down d-none d-sm-inline" },
              [
                _c("a", { staticClass: "nav-link", attrs: { href: "#" } }, [
                  _vm._v(_vm._s(_vm.trans("general.any_search_title"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav flex-filler" }),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav my-lg-0" }, [
            _c(
              "li",
              { staticClass: "nav-item hidden-sm-down" },
              [_c("global-search")],
              1
            ),
            _vm._v(" "),
            _vm.getAcademicSessions.length &&
            !_vm.hasPermission("change-academic-session")
              ? _c("li", { staticClass: "nav-item dropdown" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "nav-link dropdown-toggle text-muted waves-effect waves-dark",
                      attrs: { href: "#" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.getDefaultAcademicSession
                            ? _vm.getDefaultAcademicSession.name
                            : ""
                        )
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "dropdown-menu",
                    _vm.getConfig("user_direction") != "rtl"
                      ? "dropdown-menu-right"
                      : "",
                  ],
                },
                [_vm._m(3)]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass:
            "nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark",
          attrs: { href: "javascript:void(0)" },
        },
        [_c("i", { staticClass: "fas fa-bars" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass:
            "nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark",
          attrs: { href: "javascript:void(0)" },
        },
        [_c("i", { staticClass: "icon-arrow-left-circle fas" })]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass:
          "nav-link dropdown-toggle text-muted waves-effect waves-dark",
        attrs: {
          href: "",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fas fa-user" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "dropdown-user" }, [
      _c("li", [
        _c("div", { staticClass: "dw-user-box" }, [
          _c("div", { staticClass: "u-text" }, [_c("h6")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }